import { Link } from "react-router-dom";
import { LogoWordmark } from "@/components/Logo";
import { Phone, EnvelopeSimple, MapPin, LinkedinLogo } from "@phosphor-icons/react";
import { useContent } from "@/context/ContentContext";
import { DEFAULTS } from "@/data/contentRegistry";

export default function Footer() {
  const { content } = useContent();
  const tx = (k) => content?.[k] || DEFAULTS[k] || "";
  const customCopyright = tx("footer.copyright");
  const linkedinUrl = tx("global.linkedin.url");
  return (
    <footer data-testid="site-footer" className="border-t border-ducs-gold/15 bg-ducs-night">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <LogoWordmark />
          <p className="mt-6 text-sm text-ducs-mist leading-relaxed max-w-md whitespace-pre-line">
            {tx("footer.tagline")}
          </p>
          <div className="mt-6 space-y-2 text-sm text-ducs-mist">
            <div className="flex items-center gap-2"><MapPin size={16} className="text-ducs-gold" /> {tx("footer.location")}</div>
            <div className="flex items-center gap-2"><EnvelopeSimple size={16} className="text-ducs-gold" /> {tx("footer.email")}</div>
            <div className="flex items-center gap-2"><Phone size={16} className="text-ducs-gold" /> {tx("footer.phone")}</div>
          </div>
          {linkedinUrl && (
            <div className="mt-6">
              <a
                href={linkedinUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                aria-label="LinkedIn de Michelo Nuzzo"
                title="Suivre Michelo Nuzzo sur LinkedIn"
                className="inline-flex items-center justify-center h-10 w-10 rounded-sm border border-ducs-gold/40 text-ducs-gold hover:bg-ducs-gold hover:text-ducs-night transition-colors duration-300"
              >
                <LinkedinLogo size={20} weight="fill" />
              </a>
            </div>
          )}
        </div>

        <div>
          <div className="label-caps mb-4">{tx("footer.col1.title")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/assurances-professionnelles" className="text-ducs-cream/80 hover:text-ducs-gold">{tx("nav.assurances")}</Link></li>
            <li><Link to="/sante-prevoyance" className="text-ducs-cream/80 hover:text-ducs-gold">{tx("nav.sante")}</Link></li>
            <li><Link to="/patrimoine-placements" className="text-ducs-cream/80 hover:text-ducs-gold">{tx("nav.patrimoine")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-caps mb-4">{tx("footer.col2.title")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/partenaires" className="text-ducs-cream/80 hover:text-ducs-gold">{tx("nav.partenaires")}</Link></li>
            <li><Link to="/contact" className="text-ducs-cream/80 hover:text-ducs-gold">{tx("nav.contact")}</Link></li>
            <li><Link to="/mentions-legales" className="text-ducs-cream/80 hover:text-ducs-gold">Mentions légales</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row gap-2 justify-between items-start md:items-center text-xs text-ducs-mist">
          <div>{customCopyright || `© ${new Date().getFullYear()} Courtage des Ducs — Tous droits réservés.`}</div>
          <div className="flex items-center gap-4">
            <span>Dirigeant : Michelo Nuzzo</span>
            <span className="text-ducs-mist/40">·</span>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              aria-label="Espace administration"
              title="Administration"
              className="text-ducs-mist/40 hover:text-ducs-gold transition-colors"
            >·</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
